// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".queryPnl{margin-top:50px}.smallMenu{width:400px!important}", ""]);
// Exports
module.exports = exports;
